import { investmentInitialValue } from "@/types/app/investment";
import { notificationInitialValue } from "@/types/app/notifications";
import { schedulesInitialValue } from "@/types/app/schedules";

export default {
  modalNotification: false,
  modalNewNotification: false,
  notificationSent: false,
  modalNotificationDelete: false,
  notification: notificationInitialValue,
  notifications: [],
  schedule: schedulesInitialValue,
  modalSchedule: false,
  scheduleFeedbackModal: false,
  modalEmailNotification: false,
  modalNewEmailNotification: false,
  emailNotificationSent: false,
  modalEmailNotificationDelete: false,
  emailNotification: notificationInitialValue,
  emailNotifications: [],
};
